import { useTranslation } from 'react-i18next';

interface PageHeaderProps {
  id: string;
  rightElement?: React.ReactNode;
}

export default function PageHeader({ id, rightElement }: PageHeaderProps) {
  const { t } = useTranslation();
  const description = t(`pageDescription.${id}`, { defaultValue: '' });

  return (
    <div className="flex gap-3 compact:items-center">
      <div className="flex flex-col gap-3">
        <h1 className="compact:text-[28px] compact:leading-[1.2] compact:tracking-[-0.7px]">
          {t(`pageTitle.${id}`)}
        </h1>
        {description && (
          <p className="max-w-180 text-[14px] leading-[1.8] phone:text-[15px] text-body compact:hidden">
            {description}
          </p>
        )}
      </div>
      {rightElement && (
        <div className="ml-auto compact:[&>button]:min-w-11 compact:[&>button]:min-h-11">
          {rightElement}
        </div>
      )}
    </div>
  );
}
